import Wrapper from '../../assets/wrappers/LandingPage';

import  Header  from '../../Layouts/Header';
import FindContent from '../../Layouts/FindContent';
import Footer from '../../Layouts/Footer';
import ProfileContent from '../../Layouts/ProfileContent';


const Profile = () => {
  return (
    <Wrapper>
        <ProfileContent></ProfileContent>
        <Footer></Footer>
    </Wrapper>
  );
};

export default Profile;
